import { IPaintsConfig } from '../../models/IPaintsConfig';
import { customFetch } from '../../utils/customFetch';
import URL from '../url';

export const fetchConfig = async (tenant: string) => {
  const { url, params } = URL.fetchConfig(tenant);
  return await customFetch<IPaintsConfig>({ url, params });
};
